import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CpeService } from '../cpe.service';
import { SharedService } from '../../shared/shared.service';
import { Alerts } from '../../shared/enums/alerts';
import { HomeService } from '../../home/home.service';
import { CpeBase } from "../cpeBase";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CpeTo } from 'src/app/shared/models/cpeTo';

@Component({
    selector: 'app-update-cpe',
    templateUrl: './update-cpe.component.html',
    styleUrls: ['./update-cpe.component.scss']
})
export class UpdateCpeComponent extends CpeBase implements OnInit {

    cpeData: CpeTo;
    resetData: CpeTo;
    header = "Update CPE System";
    secretHeader = "Secret"
    title: string;
    orgDialogRef: MatDialogRef<unknown, any>;
    secret: string;
    secretDialog: MatDialogRef<unknown, any>;

    constructor(@Inject(MAT_DIALOG_DATA) public data: CpeTo,
        public dialogRef: MatDialogRef<UpdateCpeComponent>,
        public sharedService: SharedService,
        public CpeService: CpeService,
        public homeService: HomeService,
        private dialog: MatDialog) {
        super();
    }

    ngOnInit() {
        this.cpeData = { ...this.data };
        this.resetData = { ...this.cpeData };
        this.header = "Update CPE System";
        this.title = this.cpeData.cpeName;
        this.cpeName.setValue(this.data.cpeName || '');
        this.cpeName.valueChanges.subscribe(value => {
            this.cpeData.cpeName = value;
        });
    }

    updateCpe() {
        if (this.isValidData()) {
            // Check if any data has changed
            const dataChanged = JSON.stringify(this.resetData) !== JSON.stringify(this.cpeData);
            if (!dataChanged) {
                this.sharedService.showAlert(Alerts.ERROR, 'No changes detected to update.');
                return;
            }
            if (this.resetData.cpeName !== this.cpeData.cpeName) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: 'You are changing the CPE name. Do you want to proceed?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                }).then((result) => {
                    if (result.value) {
                        this.checkDuplicateCpeName();
                    } else {
                        this.dialogRef.close(true);
                    }
                });
            } else {
                this.checkDuplicateCpeName();
            }
        }
    }

    isValidData() {
        this.markFormControlsAsTouched();
        return this.cpeName.valid;
    }

    onValChange(val: string) {
        this.cpeData.cpeName = val;
    }

    clear() {
        this.fieldcheck = true;
    }

    resetCpe() {
        if (this.fieldcheck === true) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Your changes will be lost!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Reset',
                cancelButtonText: 'No, Cancel',
            }).then((result) => {
                if (result.value) {
                    this.cpeName.setValue(this.resetData.cpeName);
                }
            });
        } else {
            this.cpeName.setValue(this.resetData.cpeName);
        }
    }

    close() {
        if (this.fieldcheck === true) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Your changes will not be saved !',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Close',
                cancelButtonText: 'No, Cancel',
            }).then((result) => {
                if (result.value) {
                    this.dialogRef.close(false);
                }
            });
        } else {
            this.dialogRef.close(false);
        }
    }

    checkDuplicateCpeName() {
        this.loading = true;
        this.CpeService.getCpeList().subscribe(cpeList => {
            const duplicateCpe = cpeList.find(cpe => cpe.cpeName === this.cpeData.cpeName && cpe.id !== this.cpeData.id);
            if (duplicateCpe) {
                this.loading = false;
                this.sharedService.showAlert(Alerts.ERROR, 'CPE System with this name already exists. Please choose a different name.');
            } else {
                this.proceedToUpdate();
            }
        }, error => {
            this.loading = false;
            this.sharedService.handleErrors(error, [], "Unable to verify CPE name uniqueness");
        });
    }

    proceedToUpdate() {
        this.CpeService.updateCpe(this.cpeData).subscribe({
            next: data => {
                this.loading = false;
                this.sharedService.showAlert(Alerts.SUCCESS, 'CPE System updated successfully');
                this.dialogRef.close(true);
            },
            error: error => {
                console.error("Error updating CPE System", error);
                this.loading = false;
                this.sharedService.handleErrors(error,
                    [{
                        "condition": (error.status === 400 && Object.keys(error.error).length > 0),
                        "msg": error.error[Object.keys(error.error)[0]]
                    }],
                    "Unable to update CPE System");
            }
        });
    }

    viewSharedSecret(templateRef: TemplateRef<any>) {
        this.CpeService.getSharedSecret(this.cpeData.cpeName).subscribe(data => {
            this.secret = data;
            this.secretDialog = this.dialog.open(templateRef, { width: '650px' });
        });
    }

    closeSecret() {
        this.secretDialog.close();
    }
}
